import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { ReduxStateType } from "redux-store/types";

interface InitialState {
  status: ReduxStateType;
  data: any; // TODO
}

const initialState: InitialState = {
  status: ReduxStateType.ERROR,
  data: {},
};

const getBannerSlice = createSlice({
  name: "getBanner",
  initialState,
  reducers: {
    getBannerStart: (state) => {
      state.status = ReduxStateType.LOADING;
    },
    getBannerSuccess: (state, action: PayloadAction<{ data: any }>) => {
      state.status = ReduxStateType.SUCCESS;

      state.data = action.payload;
    },
    getBannerFailed: (state) => {
      state.status = ReduxStateType.ERROR;
    },
    resetBanner: () => {
      return { ...initialState };
    },
  },
});

export const {
  getBannerStart,
  getBannerSuccess,
  getBannerFailed,
  resetBanner,
} = getBannerSlice.actions;

export default getBannerSlice.reducer;
